import { createSlice } from "@reduxjs/toolkit"

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    //get all categories
    getCategoryStart: (state) => {
      state.isFetching = true
      state.error = false
    },
    getCategorySuccess: (state, action) => {
      state.isFetching = false
      state.categories = action.payload
    },
    getCategoryFailure: (state) => {
      state.isFetching = false
      state.error = true
    },
    //delete a category
    deleteCategoryStart: (state) => {
      state.isFetching = true
      state.error = false
    },
    deleteCategorySuccess: (state, action) => {
      state.isFetching = false
      state.categories = state.categories.filter((item) => {
        return item.id !== action.payload
      })
    },
    deleteCategoryFailure: (state) => {
      state.isFetching = false
      state.error = true
    },
    //add a category
    addCategoryStart: (state) => {
      state.isFetching = true
      state.error = false
    },
    addCategorySuccess: (state, action) => {
      state.isFetching = false
      state.categories = state.categories.concat([action.payload])
    },
    addCategoryFailure: (state) => {
      state.isFetching = false
      state.error = true
    },
  },
})

export const {
  getCategoryStart,
  getCategorySuccess,
  getCategoryFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  deleteCategoryFailure,
  addCategoryStart,
  addCategorySuccess,
  addCategoryFailure,
} = categorySlice.actions
export default categorySlice.reducer
